import { ADD_ITEM_ORDER, INVENTORY_ITEMS, CLOCKS_BILLING_ITEMS, ADD_INVENTORY_ITEMS, CLOCKS_ITEMS, CLOCK_ITEM, CLOCKS_SUMMARY } from "../../types"

const InventoryItems = (state = {}, action) => {
    if ([ADD_ITEM_ORDER, INVENTORY_ITEMS, CLOCKS_BILLING_ITEMS, ADD_INVENTORY_ITEMS, CLOCKS_ITEMS, CLOCK_ITEM, CLOCKS_SUMMARY].includes(action.type)) {
        state = { ...state, [action.type]: action.payload };
    };
    return state;
};

export default InventoryItems;